export const MARK_FINISHED_MODAL_ID = 'mark-as-finished';
